import { AxiosRequestConfig } from "axios";

import { User } from "@contexts/Auth";

import { LOCAL_STORAGE } from "../../../constants";

export const authTokenRequestInterceptor = (config: AxiosRequestConfig) => {
  const userJSON = localStorage.getItem(LOCAL_STORAGE.USER);

  if (userJSON) {
    const { accessToken } = JSON.parse(userJSON) as User;

    if (accessToken) {
      return {
        ...config,
        headers: {
          ...config.headers,
          Authorization: `Bearer ${accessToken}`,
        },
      };
    }
  }

  return config;
};
